import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';
import projects, { projectsSaga } from './projects';
import mainProjects, { mainProjectsSaga } from './mprojects';
import etcProjects, { etcProjectsSaga } from './etcs';
import project, { projectSaga } from './project';
import projectComments, { projectCommentsSaga } from './projectComments';
import projectCosts, { projectCostsSaga } from './projectCosts';
import projectEstimateCosts, {
  projectEstimateCostsSaga,
} from './projectEstimateCosts';
import projectEstimates, { projectEstimatesSaga } from './projectEstimates';
import projectEstimate, { projectEstimateSaga } from './projectEstimate';
import purchaseQuoteFiles, {
  purchaseQuoteFilesSaga,
} from './purchaseQuoteFiles';
import projectFiles, { projectFilesSaga } from './projectFiles';
import projectTechFiles, { projectTechFilesSaga } from './projectTechFiles';
import purchaseOrderFiles, {
  purchaseOrderFilesSaga,
} from './purchaseOrderFiles';
import orderLetters, { orderLettersSaga } from './orderLetters';
import orderAdd, { orderAddSaga } from './orderAdd';
import order, { orderSaga } from './order';
import salesHistory, { salesHistorySaga } from './sales-history';

import salesOrderSheet, { salesOrderSheetSaga } from './sales-order-sheet';
import buysOrderSheet, { buysOrderSheetSaga } from './buys-order-sheet';

import projectTechs, { projectTechsSaga } from './projectTechs';
import reqTechs, { ReqTechsSaga } from './techReqs';
import planTechs, { PlanTechsSaga } from './techPlans';
import rsltTechs, { rsltTechsSaga } from './techRslts';
import tech, { techSaga } from './tech';
import techPlan, { techPlanSaga } from './techPlan';
import midTechs, { MidTechsSaga } from './techMids';
import techMid, { techMidSaga } from './techMid';
import techRslt, { techRsltSaga } from './techRslt';
import techFiles, { techFilesSaga } from './techFiles';
import orderSheetSents, { orderSheetSentsSaga } from './orderSheetSents';
import projectTaxbills, { projectTaxbillsSaga } from './projectTaxbill';
import issueTaxbills, { issuedTaxbillsSaga } from './issue-taxbills';
import projectOrders, { projectOrdersSaga } from './project-orders';
import orderFiles, { orderFilesSaga } from './order-files';

const projectModule = combineReducers({
  projects,
  mainProjects,
  etcProjects,
  project,
  projectComments,
  salesHistory,
  projectCosts,
  projectEstimateCosts,
  projectEstimates,
  projectEstimate,
  purchaseQuoteFiles,
  projectFiles,
  projectTechFiles,
  purchaseOrderFiles,
  orderLetters,
  order,
  orderAdd,
  projectTechs,
  tech,
  techPlan,
  techMid,
  techFiles,
  techRslt,
  reqTechs,
  planTechs,
  midTechs,
  rsltTechs,
  orderSheetSents,
  projectTaxbills,
  issueTaxbills,
  salesOrderSheet,
  buysOrderSheet,
  projectOrders,
  orderFiles,
});

export function* projectModuleSaga() {
  yield all([
    projectsSaga(),
    mainProjectsSaga(),
    etcProjectsSaga(),
    projectSaga(),
    projectCommentsSaga(),
    salesHistorySaga(),
    projectCostsSaga(),
    projectEstimateCostsSaga(),
    projectEstimatesSaga(),
    projectEstimateSaga(),
    purchaseQuoteFilesSaga(),
    projectFilesSaga(),
    projectTechFilesSaga(),
    purchaseOrderFilesSaga(),
    orderLettersSaga(),
    orderAddSaga(),
    orderSaga(),
    techSaga(),
    techPlanSaga(),
    techMidSaga(),
    projectTechsSaga(),
    techFilesSaga(),
    techRsltSaga(),
    ReqTechsSaga(),
    MidTechsSaga(),
    PlanTechsSaga(),
    rsltTechsSaga(),
    orderSheetSentsSaga(),
    projectTaxbillsSaga(),
    issuedTaxbillsSaga(),
    salesOrderSheetSaga(),
    buysOrderSheetSaga(),
    projectOrdersSaga(),
    orderFilesSaga(),
  ]);
}

export default projectModule;
